@if (isFetching) {
  <div class="chart-skeleton-container">
    <ngx-skeleton-loader
      count="1"
      appearance="line"
      [theme]="{
        width: '125px',
        height: '28px',
        'margin-bottom': '10px',
        background: 'var(--skeleton-background)',
      }"
    ></ngx-skeleton-loader>
    <div class="chart-placeholder">
      <ngx-skeleton-loader
        count="1"
        appearance="line"
        [theme]="{
          width: '100%',
          height: '300px',
          'border-radius': '8px',
          background: 'var(--skeleton-background)',
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
}
@if (!isFetching && errorFetching) {
  <div class="section-error">
    <mat-icon>error_outline</mat-icon>
    <span>Failed to load summaries</span>
    <button class="retry-button" (click)="retry()">Retry</button>
  </div>
}
<mat-card class="summaries-card" [hidden]="isFetching || errorFetching">
  <p class="summaries-title">Summaries Count</p>
  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort class="udt-table summary-table w-100">
      <ng-container matColumnDef="summary">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Summary</th>
        <td
          mat-cell
          *matCellDef="let element"
          style="cursor: pointer"
          (click)="filterBySummary(element.summary)"
          [matTooltip]="element.summary.length > 60 ? element.summary : ''"
        >
          {{ element.summary | limitCharacters: 60 }}
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <p class="total-label">Total</p>
        </td>
      </ng-container>
      <ng-container matColumnDef="count">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Count</th>
        <td mat-cell *matCellDef="let element" style="padding-left: 15px">{{ element.count }}</td>
        <td mat-footer-cell *matFooterCellDef style="padding-left: 15px">
          <p class="total-label">{{ totalCount }}</p>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    </table>
  </div>
</mat-card>
